import { Tooltip, TooltipProps } from "@mui/material";
import { useIsStorybook } from "utils/customHooks/storyHooks";

/** Tooltip doesn't work in storybook */
export function TooltipNS({
  title,
  children,
  ...props
}: TooltipProps & {
  title: string | React.JSX.Element;
  children: React.JSX.Element | React.JSX.Element[] | string;
}) {
  const isStorybook = useIsStorybook();
  return isStorybook ? (
    <>{children}</>
  ) : (
    <Tooltip title={title} {...props}>
      {children}
    </Tooltip>
  );
}
